import React, { PropsWithChildren, ReactElement } from 'react'
import { ViewProps, StyleSheet, View } from 'react-native'
import { Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flex: 1,
  },
})

interface Props extends ViewProps {
  title?: string | ReactElement
}
const InfoHead = (props: PropsWithChildren<Props>) => {
  const { title, children, style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {typeof title === 'string' ? (
        <Text level={4} style={styles.title}>
          {title}
        </Text>
      ) : (
        title
      )}
      {children}
    </View>
  )
}

export default InfoHead
